let module = angular.module('app.resources');

module.factory('UserCapabilities', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/user/capabilities`,
    {},
    {
      get: {
        method: 'GET',
        isArray: true,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/user_capabilities.js